<template>
    <el-select :disabled="disabled" :multiple="multiple" :collapse-tags="collapse" :value="value" filterable remote
        :placeholder="queryplace" clearable @change="change" @click.native="handleSelected()"
        :remote-method="remoteMethod">
        <el-option v-for="item in ManagerOperation" :key="item.BrandLable"
        :label="item.BrandName" :value="item.BrandLable">
        </el-option>
        <!-- <div style="margin-left:50%">
            <el-pagination small layout="prev, pager, next" :total="total" :page-size="size"
                @current-change="handleCurrentChange" @size-change="handleSizeChange">
            </el-pagination>
        </div> -->
    </el-select>
</template>

<script>

import { GetBrandInUserList } from "../../api/api";
export default {
    name: "selectPBBrand",
    props: {
        value: {
            type: [String, Number],
            default() {
                return "";
            },
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            },
        },
        multiple: {
            type: Boolean,
            default() {
                return false;
            },
        },
        collapse: {
            type: Boolean,
            default() {
                return false;
            },
        },
        queryplace: {
            type: String,
            default: function () {
                return "请选择品牌标识";
            }
        },
        isEnable: {
            //是否筛选启用项目分类，默认是。选择全部默认传值空
            type: Boolean,
            default() {
                return true;
            },
        }
    },
    data() {
        return {
            typeId: "",
            ManagerOperation: [],
            typeSearch: "",//搜索
            total: 0,
            size: 20,
            page: 1,
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.page = val;
            this.GetBrandInUserList();
        },
        handleSizeChange(val) {
            this.size = val;
            this.page = 1;
            this.GetBrandInUserList();
        },
        remoteMethod(value) {
            this.typeSearch = value;
            this.page = 1;
            this.GetBrandInUserList();
        },
        GetBrandInUserList() {
            let para = {
                key: this.typeSearch,
                page: this.page,
                intPageSize: this.size
            };
            GetBrandInUserList(para).then((res) => {
                this.ManagerOperation = res.data.response ? res.data.response : [];
                if (!this.value && this.ManagerOperation && this.ManagerOperation.length > 0) {
                    this.$emit("input", this.ManagerOperation[0].BrandLable);
                }
            });
        },
        change(val) {
            this.$emit("input", val);
        },
        // 按钮点击事件
        handleSelected() {
            // 主动触发点击事件
            this.typeSearch = "";
            this.GetBrandInUserList();
        },
        check(val) {
            if (this.value != null) {
                var index = this.ManagerOperation.findIndex(s => s.BrandLable == this.value);
                if (index < 0) {
                    //this.typeSearch = val;
                    this.GetBrandInUserList();
                }
            }
        }
    },
    mounted() {
        if (this.value) {
            this.typeId = this.value;
            this.typeSearch = this.value;
        }
        this.GetBrandInUserList();
    },
    watch: {
        "value": function (val) {
            this.check(val);
        }
    },
}
</script>
